"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerSendInvoiceEmailInput = void 0;
var send_email_input_1 = require("./send-email-input");
Object.defineProperty(exports, "HaulerSendInvoiceEmailInput", { enumerable: true, get: function () { return send_email_input_1.HaulerSendInvoiceEmailInput; } });
//# sourceMappingURL=index.js.map